import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { BrandLogo } from '../components/BrandLogo';
import { useAuth } from '../auth/AuthContext';
import { appStoreUrl } from '../lib/influencerTracking';

export function DownloadPage() {
  const { user } = useAuth();
  const storeUrl = appStoreUrl();
  const paid = Boolean(user?.aiCoachingEnabled);

  return (
    <div className="app-body flex min-h-screen flex-col items-center justify-center px-4 py-12">
      <motion.div
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md text-center"
      >
        <div className="mb-6 flex justify-center">
          <BrandLogo variant="hero" />
        </div>
        <h1 className="font-display text-2xl font-bold text-[var(--text-primary)]">
          {paid ? 'Download the iOS app' : 'Almost there'}
        </h1>
        <p className="mt-3 text-sm leading-relaxed text-[var(--text-muted)]">
          {paid
            ? 'Your subscription is active. Install Peak Performance IQ on iPhone to train, log, and coach.'
            : 'Finish checkout to unlock Pro, then download the iOS app from the App Store.'}
        </p>

        {paid ? (
          <>
            <a
              href={storeUrl}
              target="_blank"
              rel="noreferrer"
              className="mt-8 inline-flex w-full items-center justify-center rounded-full bg-sky-400 px-6 py-3.5 text-sm font-semibold text-zinc-950"
            >
              Open in App Store
            </a>
            <Link
              to="/account"
              className="mt-3 inline-flex w-full items-center justify-center rounded-full border border-white/15 px-6 py-3.5 text-sm font-semibold text-white"
            >
              Manage billing
            </Link>
          </>
        ) : (
          <Link
            to="/checkout"
            className="mt-8 inline-flex w-full items-center justify-center rounded-full bg-sky-400 px-6 py-3.5 text-sm font-semibold text-zinc-950"
          >
            Continue to checkout
          </Link>
        )}

        <p className="mt-6 text-xs text-zinc-500">
          Log 25 days in your first month for 30% off month 2 (Stripe).
        </p>
        <p className="mt-8 text-sm text-[var(--text-muted)]">
          <Link to="/" className="font-semibold text-accent">
            Home
          </Link>
        </p>
      </motion.div>
    </div>
  );
}
